<template>
<!-- :style="style" -->
  <div class="login-warp" >
    <top-nav-menu>
      <div>
        <template v-for="item in menuList">
          <router-link
            v-if="item.target === 'self'"
            :class="['menu-item']"
            :key="item.name"
            :to="item.path"
            >{{ item.name }}</router-link
          >
          <a
            class="menu-item"
            v-else-if="item.target === 'blank'"
            :href="item.path"
            target="_blank"
            :key="item.name"
            >{{ item.name }}</a
          >
        </template>
      </div>
    </top-nav-menu>
     <p style="padding-top:90px"><img style="width:100%" src="../../../assets/image/2.png" alt=""></p>
    <slot></slot>
   
  </div>
</template>
<script>
import topNavMenu from "components/topNavMenu";

export default {
  name: "loginLayout",
  components: {
    topNavMenu,
  },
  data() {
    return {
      // style: {
      //   background: `url(${require("assets/image/login-bg.png")}) no-repeat top left`,
      //   backgroundSize: "cover",
      // },
      menuList: [
        {
          name: "域名注册",
          path: "/index",
          target: "self",
        },
        {
          name: "网站建设",
          path: "http://hhzh.net/case_complex.aspx?nid=4",
          target: "blank",
        },
        {
          name: "解决方案",
          path: "http://hhzh.net/case_complex.aspx?nid=4",
          target: "blank",
        },
        {
          name: "新闻资讯",
          path: "http://hhzh.net/news_complex.aspx?nid=2",
          target: "blank",
        },
        {
          name: "招聘职位",
          path: "http://hhzh.net/job.aspx?nid=11",
          target: "blank",
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.login-warp {
  position: relative;
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  // height: 100vh;
  .menu-item {
    color: #fff;
    line-height: 60px;
    font-weight: 400;
    font-size: 16px;
    margin-right: 40px;
  }
}
</style>
